import templateUrl from 'emun.salesrep/salesrep-projected-bookings-thisweek.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'
import basicController from 'servicestack/basic.controller.properties'
import ServiceBus from 'servicestack/service-bus'

class SalesRepProjectedBookingsThisWeekController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    var context = $ctrl.context || 'rep';

    var timezone = moment.tz.guess();
    this.currentDate = moment.tz(timezone).format("DD/MM/YYYY");

    this.thisWeekActivities = {
      total: 0,
      count: 0
    };
    var dashboardActivityType = salesrepConfig.dashboardActivityType || "Store Appointment";
    dashboardActivityType = dashboardActivityType.replace(" ", "%20");

    var queryCriteria = '';
    if ($ctrl.insideSales === 'true') {
      dashboardActivityType = 'Phone/Email';
      queryCriteria = 'IsInsideSales=true&';
    }

    var repFilter = "";
    var filterType = "";
    if (context == 'executive') {
      //do nothing
    }
    else if (context === 'manager') {
      filterType = 'ManagerId';
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }
    else {
      filterType = "SalesRep";
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }

    this.weeklyAverageQuery = createAutoQuery({
      url: 'QueryWeeklyBookingAverage?' + queryCriteria + 'count=weeknumber&sum=WeekAvg&GroupBy=SalesRep' + repFilter,
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function (avgArgs) {
        var totalavg = 0;
        avgArgs.results.forEach(function (result) {
          totalavg += result.sumWeekAvg / result.countweeknumber;
        });
        $ctrl.avgAppointment = totalavg / avgArgs.total;
      }
    });

    filterType = "username";
    var filterType = "";
    if (context == 'executive') {
      //do nothing
    }
    else if (context === 'manager') {
      filterType = 'ManagerId';
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }
    else {
      filterType = "username";
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }
   
    this.thisWeekActivitiesCount = createAutoQuery({
      url: 'QueryActivitiesJoin.json?' + queryCriteria + 'typeIn=' + dashboardActivityType + repFilter + '&dateRange=Week&Count=Id&GroupBy=username',
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate
      },
      onLoaded: function (args) {
        args.results.forEach(function (total) {
          $ctrl.thisWeekActivities.count += total.Total;
        });
      }
    });
  }
}

let SalesRepProjectedBookingsThisWeek = {
  bindings: {
    rep: '<',
    context: '@',
    insideSales: '@',
    salesRepId: '@'
  },
  controller: SalesRepProjectedBookingsThisWeekController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}


export default SalesRepProjectedBookingsThisWeek